module.exports = __webpack_public_path__ + "static/media/update-icon.0f6fc420.png";